(() => {
  const ROOT_SELECTOR = '[data-pdp-desktop-media]';
  const TEMPLATE_SELECTOR = '[data-pdp-desktop-media-template]';
  const MOUNT_SELECTOR = '[data-pdp-desktop-media-mount]';
  const desktopQuery = window.matchMedia('(min-width: 992px)');

  const getRoots = (scope = document) => {
    if (scope.matches?.(ROOT_SELECTOR)) return [scope];
    return Array.from(scope.querySelectorAll(ROOT_SELECTOR));
  };

  const syncRoot = (root) => {
    const mount = root.querySelector(MOUNT_SELECTOR);
    const template = root.querySelector(TEMPLATE_SELECTOR);
    if (!mount || !template) return;

    if (!desktopQuery.matches) {
      if (root.dataset.pdpDesktopMediaMounted === 'true') {
        mount.replaceChildren();
        root.dataset.pdpDesktopMediaMounted = 'false';
      }
      return;
    }

    if (root.dataset.pdpDesktopMediaMounted === 'true') return;
    mount.append(template.content.cloneNode(true));
    root.dataset.pdpDesktopMediaMounted = 'true';
  };

  const init = (scope = document) => getRoots(scope).forEach(syncRoot);
  const scheduleSync = () => window.requestAnimationFrame(() => init());

  if (window.CortailorPdpResponsiveMedia) {
    window.CortailorPdpResponsiveMedia.init(document);
    return;
  }

  window.CortailorPdpResponsiveMedia = { init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  desktopQuery.addEventListener?.('change', scheduleSync);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
